import { AlignCenter, AlignLeft, AlignRight, Monitor, Moon, Sun, ZoomIn, ZoomOut } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { usePdfViewerContext } from './pdf-viewer-provider'

export function PdfViewerToolbar() {
  const { alignment, canZoomOut, canZoomIn, settingsOpen, scale, setAlignment, setTheme, theme, zoomIn, zoomOut } =
    usePdfViewerContext()

  return (
    <div className="pointer-events-none absolute right-4 top-16 z-30">
      <div
        className={`min-w-[230px] origin-top-right rounded-xl border border-white/10 bg-black/85 p-3 text-white shadow-xl backdrop-blur transition-[opacity,transform] duration-150 ease-out motion-reduce:transition-none ${
          settingsOpen
            ? 'pointer-events-auto translate-y-0 scale-100 opacity-100'
            : 'pointer-events-none -translate-y-2 scale-95 opacity-0'
        }`}
      >
        <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-white/65">Alignments</div>
        <div className="grid grid-cols-3 gap-2">
          <Button
            aria-label="Align left"
            size="icon"
            variant="ghost"
            onClick={() => setAlignment('left')}
            className={`h-8 w-8 border border-white/15 ${
              alignment === 'left' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <AlignLeft className="size-4" />
          </Button>
          <Button
            aria-label="Align center"
            size="icon"
            variant="ghost"
            onClick={() => setAlignment('center')}
            className={`h-8 w-8 border border-white/15 ${
              alignment === 'center' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <AlignCenter className="size-4" />
          </Button>
          <Button
            aria-label="Align right"
            size="icon"
            variant="ghost"
            onClick={() => setAlignment('right')}
            className={`h-8 w-8 border border-white/15 ${
              alignment === 'right' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <AlignRight className="size-4" />
          </Button>
        </div>

        <div className="mb-2 mt-4 text-[11px] font-semibold uppercase tracking-wide text-white/65">Theme</div>
        <div className="grid grid-cols-3 gap-2">
          <Button
            aria-label="Light mode"
            size="icon"
            variant="ghost"
            onClick={() => setTheme('light')}
            className={`h-8 w-8 border border-white/15 ${
              theme === 'light' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <Sun className="size-4" />
          </Button>
          <Button
            aria-label="Dark mode"
            size="icon"
            variant="ghost"
            onClick={() => setTheme('dark')}
            className={`h-8 w-8 border border-white/15 ${
              theme === 'dark' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <Moon className="size-4" />
          </Button>
          <Button
            aria-label="System mode"
            size="icon"
            variant="ghost"
            onClick={() => setTheme('system')}
            className={`h-8 w-8 border border-white/15 ${
              theme === 'system' ? 'bg-violet-600 text-white' : 'bg-white/10 text-white hover:bg-white/20'
            }`}
          >
            <Monitor className="size-4" />
          </Button>
        </div>

        <div className="mb-2 mt-4 text-[11px] font-semibold uppercase tracking-wide text-white/65">Zoom</div>
        <div className="flex items-center gap-2">
          <Button
            aria-label="Zoom out"
            disabled={!canZoomOut}
            onClick={zoomOut}
            size="icon"
            variant="ghost"
            className="h-8 w-8 border border-white/15 bg-white/10 text-white hover:bg-white/20"
          >
            <ZoomOut className="size-4" />
          </Button>
          <div className="min-w-[64px] rounded-md border border-white/15 bg-white/10 px-2 py-1.5 text-center text-xs font-medium text-white">
            {Math.round(scale * 100)}%
          </div>
          <Button
            aria-label="Zoom in"
            disabled={!canZoomIn}
            onClick={zoomIn}
            size="icon"
            variant="ghost"
            className="h-8 w-8 border border-white/15 bg-white/10 text-white hover:bg-white/20"
          >
            <ZoomIn className="size-4" />
          </Button>
        </div>
        <div className="mt-2 text-xs text-white/70">
          Zoom range: {canZoomOut ? 'min not reached' : 'min'} / {canZoomIn ? 'max not reached' : 'max'}
        </div>
      </div>
    </div>
  )
}
